import $ from 'jquery';
import {initRangeEvents} from "./range.js";
import {initCheckboxesEvents} from "./checkbox";

$(document).ready(function() {

	$('.regiones-dropp').click(function(e) {
		$('.regiones-dropw').toggleClass("mostrar");
	});

	$('.provincia-dropp').click(function(e) {
		$('.provincia-dropw').toggleClass("mostrar");
	});

	$('.comunas-dropp').click(function(e) {
		$('.comunas-dropw').toggleClass("mostrar");
	});

	$('.propiedad-dropp').click(function(e) {
		$('.propiedad-dropw').toggleClass("mostrar");
	});

	$('.sudtipo-dropp').click(function(e) {
		$('.sudtipo-dropw').toggleClass("mostrar");
	});

	$('.tipo-dropp').click(function(e) {
		$('.tipo-dropw').toggleClass("mostrar");
	});
	
	$('.filtro-wrapper').on('click', '.regiones-container > li', function () {
		$(this).find('label').toggleClass("checkSelected");
	});
		
	initRangeEvents('#precios-wrapper', "price", priceMinValue, priceMaxValue);
	initRangeEvents('#surface-wrapper', "surface", surfaceMinValue, surfaceMaxValue);
	
	$(document).on('click', function(e){
		if(!$(e.target).hasClass('buscadorprice'))
			$('.filter-dropdown').hide();
	})
	

	  $('.presta-dropp').click(function(e){
	    $(this).parent().toggleClass("mostrar");
	  });
	
	initCheckboxesEvents();
	
	$('#searchLocationFilterForm').on('submit', function (e) {
		e.preventDefault();
	  	e.stopPropagation();
	  	$('#searchLocationFilterForm').off('submit');
		$("#param-price-min").val(jsUtils.unMaskNumber($("#param-price-min").val()));
		$("#param-price-max").val(jsUtils.unMaskNumber($("#param-price-max").val()));
		$("#param-surface-min").val(jsUtils.unMaskNumber($("#param-surface-min").val()));
		$("#param-surface-max").val(jsUtils.unMaskNumber($("#param-surface-max").val()));
		$('#searchLocationFilterForm').submit();	
	});

	$('.integer-input').each(function(i, elem) {
		jsUtils.maskInput($(elem));
	})
	jsUtils.setNumberInputs();
});

